import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

type Variables = {
  id: number;
  startDatetime: string;
  endDatetime: string;
};
type Response = Reservation[];

export const useCarCalendarReservations = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['car/calendar/reservations'],
  fetcher: (variables: Variables) => {
    let params: Record<string, any> = {
      start_datetime: variables.startDatetime,
      end_datetime: variables.endDatetime,
    };

    return client
      .get(`v2/internal/partners/reservations/calendar/cars/${variables.id}`, {
        params: params,
      })
      .then((response) => {
        return response.data.data;
      });
  },
});
